(() => {
  if (window.ssProductDemoJumpReady) return;
  window.ssProductDemoJumpReady = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ss-product-demo-jump]');
    if (!trigger) return;
    const section = trigger.closest('.shopify-section');
    const item = section?.querySelector('[data-ss-product-video]');
    const video = item?.querySelector('video');
    if (!video) return;
    event.preventDefault();
    item.open = true;
    requestAnimationFrame(() => {
      const offset = document.querySelector('#shopify-section-header, .shopify-section--header')?.getBoundingClientRect().height || 90;
      window.scrollTo({
        top: Math.max(0, video.getBoundingClientRect().top + window.scrollY - offset - 12),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      const summary = item.querySelector('summary');
      summary?.focus({ preventScroll: true });
    });
  });
})();
